/**
 * Main JavaScript Entry Point
 * This file can be used for custom features not covered by other modules
 */

// Global API namespace for Husky Shop
window.HuskyShop = window.HuskyShop || {}

// Switch product card image when clicking on variant swatches
window.switchProductImage = function (productId, imageUrl, swatchElement, secondImageUrl, variantId) {
  const productCard = swatchElement.closest('[data-product-card]')

  if (productCard) {
    productCard.dataset.currentVariantImage = imageUrl
    productCard.dataset.currentVariantSecondImage = secondImageUrl || ''

    const mainImage = productCard.querySelector(`[data-main-image="${productId}"]`)
    const mainHoverFadeClasses = ['relative', 'z-0', 'group-hover:opacity-0', 'product-card-main-hover-fade']

    if (mainImage) {
      mainImage.src = imageUrl
      if (secondImageUrl) {
        mainHoverFadeClasses.forEach((c) => mainImage.classList.add(c))
      } else {
        mainHoverFadeClasses.forEach((c) => mainImage.classList.remove(c))
      }
    }

    // Update hover image - show if second image exists, hide if not
    const hoverImage = productCard.querySelector(`[data-second-image="${productId}"]`)
    if (hoverImage) {
      if (secondImageUrl) {
        hoverImage.src = secondImageUrl
        hoverImage.classList.remove('hidden')
      } else {
        hoverImage.classList.add('hidden')
      }
    }

    // Save selected variant to localStorage
    if (variantId) {
      localStorage.setItem(`selectedVariant_${productId}`, variantId)
    }

    const allSwatches = productCard.querySelectorAll(`[data-variant-swatch="${productId}"]`)
    allSwatches.forEach((swatch) => {
      swatch.classList.remove('border-primary')
      swatch.classList.add('border-transparent', 'hover:border-gray-300')
    })

    swatchElement.classList.remove('border-transparent', 'hover:border-gray-300')
    swatchElement.classList.add('border-primary')
  }
}

/**
 * Product card: add to cart (single variant) or open quick-add modal (multiple variants)
 */
function openProductQuickAddModal(handle) {
  const modal = document.querySelector('[data-product-quick-add-modal]')
  const content = document.querySelector('[data-product-quick-add-content]')
  const loading = document.querySelector('[data-product-quick-add-loading]')
  if (!modal || !content) return

  modal.classList.remove('hidden')
  content.innerHTML = ''
  const loadingEl = document.createElement('div')
  loadingEl.className = 'flex items-center justify-center py-12'
  loadingEl.setAttribute('data-product-quick-add-loading', '')
  loadingEl.innerHTML =
    '<svg class="animate-spin h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>'
  content.appendChild(loadingEl)

  const url = `/products/${handle}?view=quick-add`
  fetch(url, { credentials: 'same-origin' })
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const source = doc.getElementById('quick-add-content')
      if (!source) {
        content.innerHTML = '<p class="text-center py-8 text-primary">Nelze načíst produkt.</p>'
        return
      }
      content.innerHTML = source.innerHTML
      const root = content.querySelector('#product-quick-add-root')
      if (root) {
        window.productFormRoot = root
        const scripts = content.querySelectorAll('script')
        scripts.forEach((s) => {
          const el = document.createElement('script')
          el.textContent = s.textContent
          document.body.appendChild(el)
          document.body.removeChild(el)
        })
        document.dispatchEvent(new CustomEvent('product-quick-add:ready'))
      }
    })
    .catch(() => {
      content.innerHTML = '<p class="text-center py-8 text-primary">Chyba při načítání.</p>'
    })
}

function closeProductQuickAddModal() {
  const modal = document.querySelector('[data-product-quick-add-modal]')
  const content = document.querySelector('[data-product-quick-add-content]')
  if (modal) modal.classList.add('hidden')
  if (content) content.innerHTML = ''
  window.productFormRoot = null
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('Husky Shop initialized')

  document.body.addEventListener('click', function (e) {
    const addBtn = e.target.closest('[data-product-card-add]')
    if (addBtn) {
      e.preventDefault()
      e.stopPropagation()
      const variantId = addBtn.getAttribute('data-variant-id')
      if (variantId && typeof window.handleAddToCart === 'function') {
        window.handleAddToCart(parseInt(variantId, 10), addBtn)
      }
      return
    }
    const quickAddBtn = e.target.closest('[data-product-card-quick-add]')
    if (quickAddBtn) {
      e.preventDefault()
      e.stopPropagation()
      if (quickAddBtn.disabled) return
      const handle = quickAddBtn.getAttribute('data-product-handle')
      if (handle) openProductQuickAddModal(handle)
      return
    }
  })

  const modal = document.querySelector('[data-product-quick-add-modal]')
  const overlay = document.querySelector('[data-product-quick-add-overlay]')
  const closeBtn = document.querySelector('[data-product-quick-add-close]')
  if (overlay) overlay.addEventListener('click', closeProductQuickAddModal)
  if (closeBtn) closeBtn.addEventListener('click', closeProductQuickAddModal)
  if (modal) {
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeProductQuickAddModal()
    })
  }

  document.addEventListener('cart:updated', function () {
    if (
      document.querySelector('[data-product-quick-add-modal]') &&
      !document.querySelector('[data-product-quick-add-modal]').classList.contains('hidden')
    ) {
      closeProductQuickAddModal()
    }
  })

  const klaviyoForm = document.querySelector('[data-klaviyo-join-tribe]')
  if (klaviyoForm) {
    const companyId = klaviyoForm.dataset.companyId
    const listId = klaviyoForm.dataset.listId
    const successMessage = klaviyoForm.dataset.successMessage || ''
    const errorMessage = klaviyoForm.dataset.errorMessage || ''
    const msgEl = klaviyoForm.querySelector('[data-klaviyo-message]')
    const submitBtn = klaviyoForm.querySelector('[data-klaviyo-submit]')

    klaviyoForm.addEventListener('submit', function (e) {
      e.preventDefault()
      if (!companyId || !listId) return

      const emailInput = klaviyoForm.querySelector('[name="email"]')
      const email = emailInput && emailInput.value ? emailInput.value.trim() : ''
      const gdpr = klaviyoForm.querySelector('[name="gdpr"]')
      if (!email || !(gdpr && gdpr.checked)) return

      if (msgEl) {
        msgEl.classList.add('hidden')
        msgEl.textContent = ''
      }
      if (submitBtn) submitBtn.disabled = true

      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Shopify theme join tribe',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { signup_source: 'join_tribe' },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      }

      const url = 'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId)

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2026-01-15',
        },
        body: JSON.stringify(body),
      })
        .then(function (res) {
          if (res.status === 202) {
            if (msgEl) {
              msgEl.textContent = successMessage
              msgEl.className =
                'max-w-[476px] mb-3 text-[13px] md:text-[14px] font-light text-emerald-700 md:text-emerald-200'
              msgEl.classList.remove('hidden')
            }
            klaviyoForm.reset()
            return
          }
          return res
            .json()
            .catch(function () {
              return {}
            })
            .then(function (data) {
              var detail = ''
              if (data && data.errors && data.errors[0] && data.errors[0].detail) {
                detail = data.errors[0].detail
              }
              if (msgEl) {
                msgEl.textContent = detail || errorMessage
                msgEl.className =
                  'max-w-[476px] mb-3 text-[13px] md:text-[14px] font-light text-red-700 md:text-red-200'
                msgEl.classList.remove('hidden')
              }
            })
        })
        .catch(function () {
          if (msgEl) {
            msgEl.textContent = errorMessage
            msgEl.className = 'max-w-[476px] mb-3 text-[13px] md:text-[14px] font-light text-red-700 md:text-red-200'
            msgEl.classList.remove('hidden')
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false
        })
    })
  }
})

// Analytics: push tagged clicks to the dataLayer. GTM → Matomo mapping is owned
// by Pixxi in GTM. Any element with data-dl-event fires an event of that name;
// extra data-dl-* attributes become properties (data-dl-location -> location).
// Capture phase so the push runs before link navigation unloads the page.
document.addEventListener(
  'click',
  function (e) {
    const el = e.target.closest && e.target.closest('[data-dl-event]')
    if (!el) return
    const payload = { event: el.getAttribute('data-dl-event') }
    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name.indexOf('data-dl-') === 0 && attr.name !== 'data-dl-event') {
        payload[attr.name.slice('data-dl-'.length).replace(/-/g, '_')] = attr.value
      }
    })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  },
  true
)

// Segmented sale countdown units (hero, sale banner, PDP, cart). Ticks every
// second; the days cell drops inside the last 48h so it isn't sitting at 00.
;(function () {
  const DAY = 86400000
  const HOUR = 3600000
  const MINUTE = 60000

  function pad(n) {
    return n < 10 ? '0' + n : String(n)
  }

  function tick() {
    const units = document.querySelectorAll('[data-sale-cd]')
    if (!units.length) return false

    let anyLive = false
    units.forEach(function (unit) {
      const end = Date.parse(unit.getAttribute('data-end'))
      const remaining = end - Date.now()
      if (isNaN(end) || remaining <= 0) {
        unit.style.display = 'none'
        return
      }
      anyLive = true

      const showDays = remaining >= 2 * DAY
      const days = Math.floor(remaining / DAY)
      const values = {
        days: days,
        hours: Math.floor((remaining % DAY) / HOUR),
        minutes: Math.floor((remaining % HOUR) / MINUTE),
        seconds: Math.floor((remaining % MINUTE) / 1000),
      }

      Object.keys(values).forEach(function (name) {
        const cell = unit.querySelector('[data-cd-cell="' + name + '"]')
        if (!cell) return
        if (name === 'days' && !showDays) {
          cell.style.display = 'none'
          return
        }
        const valueEl = cell.querySelector('[data-cd-value]')
        // Hours run 0-23 only once the days cell is carrying whole days
        const n = name === 'hours' && !showDays ? Math.floor(remaining / HOUR) : values[name]
        if (valueEl) valueEl.textContent = pad(n)
      })
    })
    return anyLive
  }

  function start() {
    if (!tick()) return
    setInterval(tick, 1000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()

/**
 * Delivery estimate (snippets/delivery-estimate.liquid). Computed client-side on
 * Europe/Berlin time because pages are cached. Dispatch is today when today is a
 * business day and the cutoff hour has not passed, otherwise the next business
 * day; the delivery window adds the transit range in business days on top.
 * Re-renders every minute so the cutoff countdown stays honest. Exposed on
 * window so the cart drawer can re-run it after it re-renders.
 */
;(function () {
  var TZ = 'Europe/Berlin'
  var DAY = 86400000

  function berlinNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date())
    var get = function (type) {
      return parseInt(parts.find((p) => p.type === type).value, 10)
    }
    return { date: Date.UTC(get('year'), get('month') - 1, get('day')), hour: get('hour'), minute: get('minute') }
  }

  function isoDay(utcMs) {
    return new Date(utcMs).toISOString().slice(0, 10)
  }

  function isBusinessDay(utcMs, closed) {
    var wd = new Date(utcMs).getUTCDay()
    return wd !== 0 && wd !== 6 && closed.indexOf(isoDay(utcMs)) === -1
  }

  function addBusinessDays(utcMs, n, closed) {
    var d = utcMs
    while (n > 0) {
      d += DAY
      if (isBusinessDay(d, closed)) n--
    }
    return d
  }

  function nextBusinessDay(utcMs, closed) {
    var d = utcMs + DAY
    while (!isBusinessDay(d, closed)) d += DAY
    return d
  }

  function fill(template, values) {
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return values[key] != null ? values[key] : ''
    })
  }

  function render(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 12
    var tMin = parseInt(el.getAttribute('data-transit-min'), 10) || 2
    var tMax = Math.max(tMin, parseInt(el.getAttribute('data-transit-max'), 10) || tMin)
    var closed = (el.getAttribute('data-closed') || '').split(',').filter(Boolean)
    var locale = el.getAttribute('data-locale') || 'de'
    var dateFmt = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' })
    var dayFmt = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' })

    var now = berlinNow()
    var shipsToday = isBusinessDay(now.date, closed) && now.hour < cutoff
    var shipDay = shipsToday ? now.date : nextBusinessDay(now.date, closed)
    var from = addBusinessDays(shipDay, tMin, closed)
    var to = addBusinessDays(shipDay, tMax, closed)

    var cutoffText
    if (shipsToday) {
      var left = cutoff * 60 - (now.hour * 60 + now.minute)
      var h = Math.floor(left / 60)
      var m = left % 60
      var time =
        h > 0
          ? fill(el.getAttribute('data-t-hours'), { h: h, m: m })
          : fill(el.getAttribute('data-t-minutes'), { m: m })
      cutoffText = fill(el.getAttribute('data-t-cutoff'), { time: time })
    } else {
      cutoffText = fill(el.getAttribute('data-t-next'), { day: dayFmt.format(new Date(shipDay)) })
    }

    var windowText = fill(el.getAttribute('data-t-window'), {
      from: dateFmt.format(new Date(from)),
      to: dateFmt.format(new Date(to)),
    })

    var windowEl = el.querySelector('[data-delivery-window]')
    var cutoffEl = el.querySelector('[data-delivery-cutoff]')
    if (windowEl) windowEl.textContent = windowText + ' '
    if (cutoffEl) cutoffEl.textContent = cutoffText
    el.classList.remove('hidden')
    el.classList.add('flex')
  }

  function initDeliveryEstimates(root) {
    ;(root || document).querySelectorAll('[data-delivery-estimate]').forEach(render)
  }

  window.initDeliveryEstimates = initDeliveryEstimates

  function start() {
    initDeliveryEstimates()
    setInterval(initDeliveryEstimates, 60000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
